/**
 *  @fileOverview: 首页-产品资料
 *  @creator: CaoYanqi
 *  @Date: 2019/6/6
 *  @Last Modified by: 
 *  @Last Modified time:
 */
import * as React from 'react'
import {connect} from 'react-redux'
import './productCard.less'
import {Empty, Spin} from "antd";
import QueueAnim from 'rc-queue-anim'
import {Link} from "react-router-dom";
import {axios_} from "../../../tools/axios_";
import { Utils } from '@/tools/utils';
import zhongyao from "../img/bg_zhongyao.png";

class ProductCard extends React.Component{
  constructor(props){
    super(props);
    this.state={
      productInfoList:[],
      spinLoading:false
    }
  }
  componentDidMount(){
    this.getProductInfoList();
  }

  /**
   *获取文章列表
   */
  getProductInfoList=()=> {
    this.setState({spinLoading:true});
    axios_({
      // url:'/api/intelligence/dashboard/fixedNewsList',
      url:'/api/intelligence/dashboard/fixedNewsListPage?index=1&count=5',
      method:'get',
      headers:{'Authorization':this.props.token}
    }).then(res=>{
      this.setState({spinLoading:false});
      // console.log(res);
      if(res.data.status==200){
        this.setState({
          productInfoList:res.data.data.list
        })
      }
    }).catch(e=>{
      this.setState({spinLoading:false});
    })
  };
  /**
   * 跳转文章
   */
  handleToArticle=(url)=>{
    window.open(url)
  };

  render() {
    const {productInfoList, spinLoading}=this.state
    return (
      <div>
        <Spin spinning={spinLoading} delay={100}>
          <div className="product_card_wrap">
            <div className="header">
              <div className="title">产品资料
                {/*<Popover placement="bottomLeft" title='' content={this.content} trigger="hover">*/}
                {/*<div className="count_tips"></div>*/}
                {/*</Popover>*/}
              </div>
              {/* <Link to={'/policySys/longOrder'}>线上保单</Link> */}
            </div>
            <div className="card_box">
              <div className="card_box_content">
                <QueueAnim type='bottom' duration={100} >
                  {
                    productInfoList[0] &&
                    <div className="item_first_wrap"
                      key="item_first"
                      onClick={() => {
                        Utils.customTrack('MerchantHomeClick', {
                          element_content: '产品资料'
                        });
                        Utils.customTrack('MerchantHomeMaterialClick', {
                          material_id: productInfoList[0].newsId || '',
                          material_name: productInfoList[0].articleTitle || '',
                          material_url: productInfoList[0].articleUrl || ''
                        });
                        this.handleToArticle(productInfoList[0].articleUrl)
                      }}>
                      <div className="adver">
                        <img src={productInfoList[0].thumbnailUrl} alt='' />
                      </div>
                      <div className="title_box">
                        <div className="title"><span>{productInfoList[0].articleTitle}</span></div>
                        <span className="desc">{productInfoList[0].abstractDesc}</span>
                      </div>
                    </div>
                  }
                  {
                    (productInfoList && productInfoList.slice(1)).map((item, index) => {
                      return (
                        <div className="item_wrap"
                          key={index}
                          onClick={() => {
                            Utils.customTrack('MerchantHomeClick', {
                              element_content: '产品资料'
                            });
                            Utils.customTrack('MerchantHomeMaterialClick', {
                              material_id: item.newsId || '',
                              material_name: item.articleTitle || '',
                              material_url: item.articleUrl || ''
                            });
                            this.handleToArticle(item.articleUrl)
                          }}>
                          <span className="title">{item.articleTitle || ''}</span>
                          <span className="date_time">{item.createdTime && item.createdTime.split(' ')[0]}</span>
                        </div>
                      )
                    })
                  }
                </QueueAnim>
                {
                  !spinLoading && productInfoList.length===0 &&
                  <div className="empty-box" key={'empty'}>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                  </div>
                }
              </div>
              <Link to={'/system/productInfoList'} className="expand_btn" key="btn" onClick={()=>{
                Utils.customTrack('MerchantHomeClick', {
                  element_content: '产品资料-查看全部'
                });
              }}>查看全部</Link>
            </div>
          </div>
        </Spin>
      </div>
    )
  }
}

function mapState(state) {
  return {
    token: state.token
  }
}
export default connect(mapState)(ProductCard)
